module.exports = __webpack_public_path__ + "img/icon_login.9449b16d.svg";